import { render } from "./ManageProject.vue?vue&type=template&id=61ad2902&scoped=true"
import script from "./ManageProject.vue?vue&type=script&lang=js"
export * from "./ManageProject.vue?vue&type=script&lang=js"

import "./ManageProject.vue?vue&type=style&index=0&id=61ad2902&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61ad2902"]])

export default __exports__